export default __webpack_public_path__ + "static/media/ranes4.10efb3c7.jpg";